import React, { useState } from "react";
import { Link } from "react-scroll";
import hamburger from "../../../img/burger.svg";
import OpenMenu from "./OpenMenu/OpenMenu.jsx";
import './Menu.css';
import { t } from "i18next";

const Menu = (props) => {
  const [showText, setShowText] = useState(false);
  const onClick = () => setShowText(true);
  const onClickclose = () => setShowText(false);
  const pageLink = window.location.href.toString();
  const indexUtm = pageLink.indexOf('?');
  const utm = pageLink.slice(indexUtm+1);

    return (
      <>
        <ul className='menu'>
          <li className='menu_pc'>
              <Link
              activeClass="active"
              to='mission'
              spy={true}
              smooth={true}
              offset={-74}
              >
              {t("header.menu_mission")}
            </Link>
          </li>
          <li className='menu_pc'>
              <Link
              activeClass="active"
              to='topics'
              spy={true}
              smooth={true}
              offset={-74}
              >
              {t("header.menu_theme")}
            </Link>
          </li>
          <li className='menu_pc'>
              <Link
              activeClass="active"
              to='partners'
              spy={true}
              smooth={true}
              offset={-74}
              >
              {t("header.menu_partner")}
            </Link>
          </li>
          {/* <li className='menu_pc'>
              <Link
              activeClass="active"
              to='speakers'
              spy={true}
              smooth={true}
              offset={-74}
              >
                Спікери
            </Link>
          </li> */}
          <li className='menu_pc'>
              <Link
              activeClass="active"
              to='agenda'
              spy={true}
              smooth={true}
              offset={-74}
              >
                {t("header.menu_shedule")}
            </Link>
          </li>
          <li className='menu_pc'>
              <a
              href={`https://geekle.us/ticketfree/1646932857434x557347668339458050?lang=ua${indexUtm !== -1 ? `&${utm}` : ''}`}
              target='_blank'
              rel="noreferrer"
              >
              {t("header.menu_registration")}
            </a>
          </li>
          <li className='menu_pc'>
              <Link
              activeClass="active"
              to='team'
              spy={true}
              smooth={true}
              offset={-74}
              >
              {t("header.menu_team")}
            </Link>
          </li>
          <div className="mobile-menu">
          <div className="mobile-menu_img-block">
            <img className="mobile-menu_img" alt='' src={hamburger} onClick={onClick} className="hamburgerMenu mobile-menu-img" />
          </div>
          <div>
            {showText ? (
              <OpenMenu close={onClickclose} />
            ) : null}
          </div>
        </div>
        </ul>
      </> 
    );
  }
        
export default Menu;